const eversendSupportedCountries = [
  { country: 'Uganda', countryCode: 'UG' },
  { country: 'Kenya', countryCode: 'KE' },
  { country: 'Ghana', countryCode: 'GH' },
  { country: 'Rwanda', countryCode: 'RW' },
  { country: 'Cameroon', countryCode: 'CM' },
  { country: 'Ivory Coast', countryCode: 'CI' },
  { country: 'Tanzania', countryCode: 'TZ' }
];

const eversendSupportCurrencies = ['UGX', 'KES', 'GHS', 'RWF'];

export {
  eversendSupportedCountries,
  eversendSupportCurrencies
};
